import React from 'react';
import StatsGrid from './StatsGrid';
import Charts from './Charts';
import RecentPurchases from './RecentPurchases';

const FinanceTab = ({
  stats,
  loading,
  currency,
  currentPeriod,
  onPeriodChange,
  onUserClick
}) => {
  return (
    <div className="tab-content">
      <StatsGrid
        stats={stats}
        currency={currency}
        currentPeriod={currentPeriod}
        onPeriodChange={onPeriodChange}
      />
      <Charts stats={stats} currency={currency} />
      <RecentPurchases
        currency={currency}
        onUserClick={onUserClick}
      />
    </div>
  );
};

export default FinanceTab;
